var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"mode":"out-in"}},[_c('router-view',{on:{"save-score":_vm.saveScore}})],1),_c('login-view',{on:{"log-in":_vm.logIn,"log-out":_vm.logOut}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }